export const API_URL = process.env.GATSBY_API_URL as string;
export const APP_URL = process.env.GATSBY_APP_URL as string;
export * from './global';
export * from './anchors';
